import { FullScreenMembershipDialog } from '@colonist/clientforge';
import { mountDialogUIReactComponent } from '../ui_platform/mountDialogUIReactComponent.tsx';
import { uiManagerEvents } from '../EntryShared.ts';
const renderFullScreenMembershipDialog = mountDialogUIReactComponent(FullScreenMembershipDialog);
export function showFullScreenMembershipDialog() {
    renderFullScreenMembershipDialog({
        onConfirm: ()=>uiManagerEvents.premiumMembershipCheckAction()
    });
}
